"use strict";

const strf = require("./string.format.js");

/*
 *
 * Network functions
 *
 */

class MetaStreamIONetwork {
  constructor({ constants, endpoints, logger, silentMode, headers } = {}) {
    this.silentMode = silentMode;
    this.constant = constants;
    this.endpoint = null;
    this.endpoints = Array.isArray(endpoints) ? endpoints : [];
    this.headers = headers;
    this.logger = logger;
  }

  reset() {
    this.endpoint = null;
  }

  async testConnection() {
    if (!this.endpoint || this.endpoint === null) {
      for (let _e in this.endpoints) {
        this.endpoint = await this.getData({ endpoint: this.endpoints[_e] })
          .then((data) => {
            try {
              if (data.status === 200) {
                return this.endpoints[_e];
              }
            } catch (err) {
              return false;
            }
          })
          .catch(() => {});
        if (this.endpoint) {
          this.logger.log(
            "network",
            this.constant.MetaStreamIO_Network_EndpointSet.format(this.endpoint)
          );
          break;
        } else {
          this.logger.error(
            "network",
            this.constant.MetaStreamIO_Network_EndpointTestFailed.format(
              this.endpoint
            )
          );
          this.logger.warn(
            "network",
            this.constant.MetaStreamIO_Network_SilentModeEnabled
          );
        }
      }
    }

    return Promise.resolve(this.endpoint);
  }

  async getData({ endpoint = this.endpoint } = {}) {
    this.logger.warn("network", "endpoint", endpoint);
    var rx;

    let get_config = {
      method: "GET",
      // mode: "no-cors", // required for local testing
      cache: "no-cache",
      credentials: "same-origin",
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
      headers: {},
    };

    if (this.headers !== null) {
      get_config.headers = Object.assign(get_config.headers, this.headers);
    }

    try {
      rx = await fetch(endpoint, get_config)
        .then((response) => {
          if (response.status == 200) {
            return response.json();
          }
        })
        .then((data) => {
          this.logger.log("network", data);
          return Promise.resolve({
            body: data,
            status: 200,
          });
        })
        .catch((err) => {
          return Promise.resolve({
            body: err,
            status: 400,
          });
        });
    } catch (err) {
      return Promise.reject(err);
      this.logger.error(
        "network",
        this.constant.MetaStreamIO_Network_GetDataIssue.format(err, endpoint)
      );
    }
    this.logger.log("network", JSON.stringify(rx));
    return rx;
  }

  async postData({ data = {}, endpoint = null } = {}) {
    var ret;

    var _endpoint = this.endpoint + (endpoint ? endpoint : "");

    this.logger.log(
      "network-request",
      this.constant.MetaStreamIO_Log_RequestObject
    );
    this.logger.json("network-request", data);

    if (this.silentMode) {
      return {
        body: this.constant.MetaStreamIO_Network_SilentMode,
        status: 1,
      };
    }

    if (!this.endpoint) {
      _endpoint = await this.testConnection()
        .then((rx_endpoint) => {
          return Promise.resolve(rx_endpoint + (endpoint ? endpoint : ""));
        })
        .catch((err) => err);
    }

    if (_endpoint) {
      return await this.post({
        data: data,
        endpoint: _endpoint,
      })
        .then((post_return) => {
          return Promise.resolve(post_return);
        })
        .catch((err) => {
          return Promise.resolve(err);
        });
    } else {
      return {
        body: this.constant.MetaStreamIO_Network_PostDataIssue.format(
          "attempted to reset network",
          _endpoint
        ),
        status: 400,
      };
    }
  }

  async post({ data = {}, endpoint = this.endpoint } = {}) {
    let rx = {};

    let post_config = {
      method: "POST",
      // mode: "no-cors", // required for local testing
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data),
    };

    if (this.headers !== null) {
      post_config.headers = Object.assign(post_config.headers, this.headers);
    }

    try {
      rx = await fetch(endpoint, post_config)
        .then(async (response) => {
          if (response.status >= 200 && response.status <= 299) {
            return {
              status: response.status,
              json: await response.json(),
            };
          } else {
            this.logger.warn("network", response.status);
            return Promise.reject("no json in response: " + response.status);
          }
        })
        .catch((err) => {
          this.logger.error("network", "fetch() response", err);
          return {
            status: 0,
            json: JSON.parse(JSON.stringify(err)),
          };
        });
    } catch (err) {
      this.logger.error("network", "post", String(err));
      rx = {
        status: 0,
        json: JSON.parse(JSON.stringify(err)),
      };
    }

    return rx;
  }
}

module.exports = MetaStreamIONetwork;
